let promiseTimeout;

export function clearTimeoutPromise() {
  if (promiseTimeout) {
    clearTimeout(promiseTimeout);

    promiseTimeout = null;
  }
}

export function timeoutPromise(timeout, clearTimeout = true) {
  return new Promise((resolve) => {
    if (clearTimeout) {
      clearTimeoutPromise();
    }

    promiseTimeout = setTimeout(() => {
      if (clearTimeout) {
        clearTimeoutPromise();
      }

      resolve();
    }, timeout);
  });
}
